import * as React from 'react';

type Props = {
  options: string[];               // e.g. ['in', 'mm'] or ['Yes', 'No'] or ['Imperial', 'Metric']
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
};

/**
 * V3UnitToggle — small segmented control for unit / boolean choice.
 *
 * Used in:
 *  - Module specs: in/mm, lbs/kg, ft²/m²
 *  - Building section: Yes/No toggles (Stagger Attachments, MLPE, etc.)
 *  - Modal step 3: in/mm
 *  - Global: Imperial/Metric (per decision: ONE common setting, not per-field)
 *
 * The existing UBuilder has no dedicated toggle component — unit
 * changes are dispatched via SET_PROJECT_OPTION('input_unit', ...).
 * The `ShowToggleUnits` logic in ProjectConfigurationComponent
 * checks product + user permissions before showing unit controls.
 *
 * V3UnitToggle is generic — pass any 2+ string options.
 */
const V3UnitToggle: React.SFC<Props> = ({ options, value, onChange, disabled = false }) => (
  <div className={`v3-unit-toggle ${disabled ? 'disabled' : ''}`}>
    {options.map((opt) => (
      <button
        key={opt}
        type="button"
        className={value === opt ? 'active' : ''}
        disabled={disabled}
        onClick={() => onChange(opt)}
      >
        {opt}
      </button>
    ))}
  </div>
);

export default V3UnitToggle;
